import { LockKeyhole } from "lucide-react";

import { IgGrayPrimitives } from "@intelligems/ig-design-tokens";
import { IgChip } from "@intelligems/ig-theme";

export const GateTrialExclusionChip = () => (
  <IgChip
    color="info"
    icon={<LockKeyhole size={14} />}
    label="Not included in free trial"
    sx={{
      backgroundColor: IgGrayPrimitives[400],
      borderColor: "transparent",
      color: IgGrayPrimitives.A300,
      fontSize: "10px",
      fontWeight: 700,
      letterSpacing: "0.5px",
      px: "10px",
      py: "4px",
      textTransform: "uppercase",
    }}
  />
);
